export const USER_SIGNED_IN = 'user-signed-in';

export const USER_SIGNED_OUT = 'user-signed-out';
